// strona dashboardu - zmiana kolejności sekcji
// @ts-nocheck

import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import { reduxActions, useDispatch } from 'store';
import { PageTitle } from 'components/controls';
import { Payments, Summary, Orders, Invoices } from 'pages/Dashboard/components';

import styles from 'theme/pages/Dashboard/Dashboard.module.scss';

const Dashboard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // ustawieni breadcrumbs'ów na starcie strony
  useEffect(() => {
    dispatch(reduxActions.setBreadcrumbs([{ name: t('Dashboard') }]));
  }, []);

  return (
    <div className={classnames(styles.componentWrapper, 'StylePath-Pages-Dashboard')}>
      <Grid container columnSpacing="32px">
        <Grid item xs={12} md={9}>
          <Summary />
          <Payments />
          <Orders />
        </Grid>
        <Grid item xs={12} md={3}>
          <Invoices />
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;